import styled from 'styled-components';
import { Width } from '../../types';
import { Banner } from '../Banner';

export const TextFieldContainer = styled.div<{ width?: Width }>`
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacing-xxs) * 2);
  width: ${(p) => p.width ?? 'fit-content'};
`;

export const TextFieldInputContainer = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-m) var(--spacing-s);
  color: var(--color-interface-content-lighter);
  background: var(--color-interface-neutral-light);
  border: 1px solid var(--color-interface-layout-normal);
  border-radius: var(--radius-8);

  > * {
    margin-right: var(--spacing-s);
  }

  > svg:last-child {
    margin-right: 0;
    margin-left: auto;
  }

  > svg {
    flex-shrink: 0;
  }

  > input {
    border: unset;
    font-family: 'DM Sans', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    outline: none;
    width: 100%;
    text-overflow: ellipsis;
    color: inherit;

    &::placeholder {
      color: var(--color-interface-content-lighter);
    }

    &:disabled {
      background: unset;
      color: var(--color-interface-layout-darkest);

      &::placeholder {
        color: inherit;
      }
    }
  }

  &:focus-within,
  &:hover {
    color: var(--color-interface-content-normal);
    border-color: var(--color-interface-secondary-normal);
  }

  // Text area  filled > change the color of the container items
  :has(input:not(:placeholder-shown)) {
    color: var(--color-interface-content-normal);
  }

  // Text area disabled > change the color of the container items
  :has(input:disabled) {
    color: var(--color-interface-layout-darkest);
    border: 1px solid var(--color-interface-layout-normal);
  }
`;

export const TextFieldErrorBanner = styled(Banner).attrs({ severity: 'error' })`
  padding: calc(var(--spacing-xxs)) var(--spacing-s);
  width: 100%;
  gap: calc(var(--spacing-xxs) * 2);
`;
